import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {Amplify} from 'aws-amplify';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AmplifyAuthenticatorModule } from '@aws-amplify/ui-angular';
import { environment } from '../environments/environments';
import { CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { LoginComponent } from './Components/PreAuth/Login/login.component';
import { AttendanceComponent } from './Components/attendance/attendance.component';
import {FormsModule} from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { TokenInterceptorService } from '../services/TokenInteceptor';
import { PasswordResetComponent } from './Components/preauth/password-reset/password-reset.component';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { ScanHistoryComponent } from './components/scan-history/scan-history.component';
import { BarcodeHistoryComponent } from './components/tools/barcode-history/barcode-history.component';
import {EpochToLocalTimePipe } from './pipes/epoch-to-local-time.pipe';
import { GatesComponent } from './components/tools/gates/gates.component';
import { DeleteGateComponent } from './components/tools/gates/delete-gate/delete-gate.component';
import { AddGateComponent } from './components/tools/gates/add-gate/add-gate.component';
import { EditGateComponent } from './components/tools/gates/edit-gate/edit-gate.component';
import { ScannerComponent } from './components/tools/scanner/scanner.component';
import { FeedsComponent } from './components/feeds/feeds.component';
import {BaseChartDirective, provideCharts,withDefaultRegisterables} from 'ng2-charts';
import { AddFeedsComponent } from './Components/feeds/add-feeds/add-feeds.component';
import { UserManagementComponent } from './Components/user-management/user-management.component';
import { EditUserComponent } from './Components/user-management/edit-user/edit-user.component';
import { NewUserComponent } from './Components/user-management/new-user/new-user.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { ShareFeedComponent } from './components/PreAuth/share-feed/share-feed.component';
import { AdminComponent } from './Components/admin/admin.component';
import { VenuesTabComponent } from './Components/admin/venues/venues-tab.component';
import { AddVenueComponent } from './Components/admin/venues/add-venue/add-venue.component';
import { PerformanceComponent } from './Components/performance-testing/performance.component';
import { AddPerformanceComponent } from './Components/performance-testing/add-performance/add-performance.component';
import { EditPerformanceComponent } from './Components/performance-testing/edit-performance/edit-performance.component';
import { PerformanceDetailComponent } from './Components/performance-testing/performance-detail/performance-detail.component';
import { AdvanceStageComponent } from './Components/performance-testing/advance-stage/advance-stage.component';
import { GateGroupsComponent } from './Components/performance-testing/gate-groups/gate-groups.component';
import { SetRulesComponent } from './Components/performance-testing/set-rules/set-rules.component';
import { SrScanPeriodModalComponent } from './Components/performance-testing/set-rules/sr-scan-period-modal.component';
import { SrEventsModalComponent } from './Components/performance-testing/set-rules/sr-events-modal.component';
import { SrAccessGroupModalComponent } from './Components/performance-testing/set-rules/sr-access-group-modal.component';
import { SrSectionRowModalComponent } from './Components/performance-testing/set-rules/sr-section-row-modal.component';
import { SrTicketUsageModalComponent } from './Components/performance-testing/set-rules/sr-ticket-usage-modal.component';
import { SrPriceCodeModalComponent } from './Components/performance-testing/set-rules/sr-price-code-modal.component';
import { SrAccessGroupManagerComponent } from './Components/performance-testing/set-rules/sr-access-group-manager.component';
import { AlertsComponent } from './Components/performance-testing/alerts/alerts.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TooltipDirective } from './directives/tooltip.directive';
import { RollingCounterComponent } from './Components/attendance/rolling-counter/rolling-counter.component';
import { FireworksComponent } from './Components/attendance/fireworks/fireworks.component';
import { ModernSummaryComponent } from './Components/attendance/modern-summary/modern-summary.component';
import { EntranceGroupsComponent } from './Components/attendance/entrance-groups/entrance-groups.component';
import { VenueSelectorComponent } from './Components/attendance/venue-selector/venue-selector.component';
import { DashboardComponent } from './Components/dashboard/dashboard.component';
import { HistoricalDataModalComponent } from './Components/dashboard/historical-data-modal/historical-data-modal.component';
import { BigScreenDashboardComponent } from './Components/attendance/big-screen-dashboard/big-screen-dashboard.component';
import { WidgetHostComponent } from './Components/attendance/big-screen-dashboard/widget-host/widget-host.component';
import { WidgetContentComponent } from './Components/attendance/big-screen-dashboard/widget-content/widget-content.component';
import { WidgetConfigComponent } from './Components/attendance/big-screen-dashboard/widget-config/widget-config.component';
import { AddWidgetComponent } from './Components/attendance/big-screen-dashboard/add-widget/add-widget.component';
import { VenueMapWidgetComponent } from './Components/attendance/big-screen-dashboard/venue-map-widget/venue-map-widget.component';

  
Amplify.configure({
  Auth: {
    Cognito: {  
      userPoolId: environment.cognito.userPoolId,
      userPoolClientId: environment.cognito.userPoolWebClientId
    }
  }
});

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    AttendanceComponent,
    PasswordResetComponent,
    ScanHistoryComponent,
    BarcodeHistoryComponent,
    EpochToLocalTimePipe,
    GatesComponent,
    DeleteGateComponent,
    AddGateComponent,
    EditGateComponent,
    ScannerComponent,
    FeedsComponent,
    AddFeedsComponent,
    UserManagementComponent,
    EditUserComponent,
    NewUserComponent,
    ShareFeedComponent,
    AdminComponent,
    VenuesTabComponent,
    AddVenueComponent,
    PerformanceComponent,
    AddPerformanceComponent,
    EditPerformanceComponent,
    PerformanceDetailComponent,
    AdvanceStageComponent,
    GateGroupsComponent,
    SetRulesComponent,
    SrScanPeriodModalComponent,
    SrEventsModalComponent,
    SrAccessGroupModalComponent,
    SrSectionRowModalComponent,
    SrTicketUsageModalComponent,
    SrPriceCodeModalComponent,
    SrAccessGroupManagerComponent,
    AlertsComponent,
    TooltipDirective,
    RollingCounterComponent,
    FireworksComponent,
    ModernSummaryComponent,
    EntranceGroupsComponent,
    VenueSelectorComponent,
    DashboardComponent,
    HistoricalDataModalComponent,
    BigScreenDashboardComponent,
    WidgetHostComponent,
    WidgetContentComponent,
    WidgetConfigComponent,
    AddWidgetComponent,
    VenueMapWidgetComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AmplifyAuthenticatorModule,
    FormsModule,
    HttpClientModule,
    BaseChartDirective,
    DragDropModule,
    NgCircleProgressModule.forRoot({
      radius: 60,
      outerStrokeWidth: 10,
      innerStrokeWidth: 5,
      showSubtitle: false,
      animationDuration: 300,
      outerStrokeColor: "#4882c2",
      innerStrokeColor: "#e7e8ea",
      showUnits: false
    }),
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptorService,
    multi: true,
  },
  provideCharts(withDefaultRegisterables())],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
